<script>
import { produitsAjoutesPanierProps } from "./mixin";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider";
import Button from "@/components/atoms/button";
import ButtonGroup from "@/components/molecules/button-group";
import LazyImage from "@/components/atoms/lazy-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import Titre from "@/components/atoms/titre";
import LoadingSpinner from "@/components/molecules/loading-spinner";

export default {
  name: "ProduitsAjoutesPanier",
  components: {
    Badge,
    Icon,
    Divider,
    List,
    ListItem,
    LazyImage,
    Button,
    Titre,
    ButtonGroup,
    LoadingSpinner
  },
  props: {
    ...produitsAjoutesPanierProps()
  },
  emits: ["showSimilaires", "close", "open_encart_panier"]
};
</script>

<template>
  <div class="c-produits-ajoutes-panier">
    <template v-if="isLoading">
      <LoadingSpinner message="Ajout de vos produits en cours..." />
    </template>

    <template v-else>
      <div class="u-mb-md u-flex u-flex-align-center u-flex-justify-center">
        <Badge
          circle
          variant="season"
          size="xlg"
          class="u-mr-sm"
        >
          <Icon
            name="check"
            variant="white"
          />
        </Badge>
        <Titre
          tag="h1"
          size="sm"
        >
          Produits ajoutés au panier
        </Titre>
      </div>

      <Divider
        dotted
        class="u-mt-md u-mb-md u-ml-lg u-mr-lg u-ml-none@md u-mr-none@md"
      />

      <div
        v-if="articlesIndisponibles && articlesIndisponibles.length > 0"
        class="u-ml-lg u-mr-lg u-ml-none@md u-mr-none@md"
      >
        <Titre
          tag="h2"
          size="sm"
          class="u-mb-md"
        >
          <template v-if="articlesIndisponibles.length > 1">
            {{ articlesIndisponibles.length }} produits sont indisponibles
          </template>
          <template v-else>
            {{ articlesIndisponibles.length }} produit est indisponible
          </template>
        </Titre>
        <div class="u-flex u-mb-sm u-text-left">
          <Icon
            name="alert-circle-outline"
            variant="primary"
            class="u-mr-xs"
            size="md"
          />
          <p class="u-color-grey-1 u-font-14">
            Les produits suivants sont indisponibles actuellement. Ils seront retirés de votre commande.
            <br>
            Vous pouvez choisir parmi les produits suggérés pour les remplacer dès maintenant ou plus tard depuis votre panier.
          </p>
        </div>
        <List>
          <ListItem
            v-for="article in articlesIndisponibles"
            :key="article.id"
            class="c-produits-ajoutes-panier__list-item u-flex u-flex-wrap@md u-flex-align-center"
          >
            <LazyImage
              :src="article.visuel"
              width="80"
              height="80"
              :dimension="96"
            />
            <p class="u-ml-sm u-mr-sm u-font-15 u-flex-align-center u-flex-grow">
              {{ article.designation }}
            </p>
            <div class="u-full-width@sm u-text-right@sm u-mt-sm@sm">
              <Button
                variant="primary"
                radius="full"
                size="sm"
                @click="$emit('showSimilaires', article)"
              >
                Voir les produits similaires
              </Button>
            </div>
          </ListItem>
        </List>
      </div>
      <ButtonGroup
        center
        class="u-mt-md"
      >
        <Button
          outline
          variant="primary"
          size="md"
          radius="full"
          class="u-mr-lg"
          @click="$emit('close')"
        >
          Je continue mes courses
        </Button>
        <Button
          variant="secondary"
          size="md"
          radius="full"
          class="u-ml-lg"
          @click="$emit('open_encart_panier')"
        >
          Voir mon panier
        </Button>
      </ButtonGroup>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.c-produits-ajoutes-panier__prices {
  padding: 0 spacing(lg) 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.c-produits-ajoutes-panier__price-crossed {
  font-size: fontSize(10);
  text-decoration: line-through;
  color: color(text-light);
}
.c-produits-ajoutes-panier__price-amount {
  font-weight: 700;
}

.c-produits-ajoutes-panier__unit-price {
  color: color(text-light);
  font-size: fontSize(12);
}
.c-produits-ajoutes-panier__list-item {
  padding-bottom: spacing(md);
  padding-top: spacing(md);
  border-bottom: 1px solid color(grey-4);
  &:last-child {
    border-bottom: none;
  }
}
</style>
